import { useEffect } from 'react';
import { Box, Typography, Link } from '@mui/material';

export function LoggedInFooter() {

    useEffect(() => {
        if (window.Termly) {
            window.Termly.initialize();  // we have to initialize Termly again after the component is mounted for it to attach to the rendered DOM
        }
    }, []);

    return  <Box bottom={0} left={0} width="100%" sx={{
                minWidth: "1280px", 
                height: "auto", // Removed fixed height constraint
                border: 0,
                display: {xs: 'none', md: 'flex'},
                flexDirection: 'column',
                alignItems: 'center',
                
                gap: '4px' // Add spacing between elements
            }}>  
                <Box sx={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                    <Typography align="center" fontSize="0.6rem">Copyright &copy; 2024 Revelata, Inc.&nbsp;&nbsp;All rights reserved.</Typography>
                    <Link href="https://app.termly.io/policy-viewer/policy.html?policyUUID=b23e7803-82d9-4a25-8575-b1ac84488757" target="_blank" sx={{fontSize: "0.6rem", color: "var(--mui-palette-primary-light)"}}>Terms of Service</Link>
                    <Typography sx={{fontSize: "0.6rem"}}>|</Typography>
                    <Link href="https://app.termly.io/policy-viewer/policy.html?policyUUID=d43ea6b9-44c7-4fae-b1c7-904c815b67c8" target="_blank" sx={{fontSize: "0.6rem", color: "var(--mui-palette-primary-light)"}}>Privacy Policy</Link>
                    <Typography sx={{fontSize: "0.6rem"}}>|</Typography>
                    <Link href="#" className="termly-display-preferences" sx={{fontSize: "0.6rem", color: "var(--mui-palette-primary-light)"}}>Consent Preferences</Link>
                </Box>
            </Box>
}

export default LoggedInFooter;